import { LoginComponent } from './components/login/login.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CellphoneValidationComponent } from './components/mfa/phone-validation/cellphone-validation.component';
import { EnrollmentGuard } from '../guards/enrollment.guard';
import { EmailLinkValidationComponent } from './components/mfa/email-link-validation/email-link-validation.component';
import { LoginFreshDeskComponent } from './components/loginfreshdesk/loginfreshdesk.component';
import { LogoutfreshdeskComponent } from './components/logoutfreshdesk/logoutfreshdesk.component';
import { MessageComponent } from './components/message/message.component';

const routes: Routes = [
    { path: 'cell-phone-validation', component: CellphoneValidationComponent, data: { state: 'cellphonevalidation' }, canActivate: [EnrollmentGuard] },
    { path: 'email-link-validation', component: EmailLinkValidationComponent },
    { path: 'loginfreshdesk', component: LoginFreshDeskComponent },
    { path: 'logoutfreshdesk', component: LogoutfreshdeskComponent },
    { path: 'message', component: MessageComponent },
    { path: '', component: LoginComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthRoutingModule { }
